var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('tu-ui-icon',{staticClass:"tu-destination-icon",attrs:{"name":_vm.icon,"size":18}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }